import React from 'react';

import Dialog from 'crehana-ui/Dialog';

import useOnClickOutside from 'Shared/Hooks/useOnClickOutside';
import useKeyPress, { commonKeyCodes } from 'Shared/Hooks/useKeyPress';
import { useMe } from 'Jsx/ContextApis/AuthContext';

import Player from './Player';

const DialogVideoPlayer = ({ course, open: isOpen, hideCourseTrailer }) => {
  const innerRef = React.useRef<HTMLDivElement>(null);

  const { loading, me } = useMe();

  useOnClickOutside(innerRef, hideCourseTrailer);

  useKeyPress({
    targetKey: commonKeyCodes.escape,
    handler: hideCourseTrailer,
    onlyRunIf: isOpen,
  });

  return (
    <Dialog
      open={isOpen}
      onDismiss={hideCourseTrailer}
      size="s"
      containerHTMLProps={{
        style: {
          width: 'auto',
          maxWidth: '100%',
          marginLeft: 0,
        },
      }}
      hideCloseBtn
      hideDialogSheet
    >
      <div className="w-full h-full flex items-center justify-center">
        <div ref={innerRef}>
          <Player {...course} userIsAffiliate={!loading && me?.isAffiliate} />
        </div>
      </div>
    </Dialog>
  );
};

export default DialogVideoPlayer;
